<template>
    <div class="player">
        <div class="player-controls">

            <div class="container-1">
                <div class="cont-1-1">
                    <img :src="'/images/' + current.data.thumb" class="img-fluid" :title="current.data.titulo">
                </div>
                <div class="cont-1-2">
                    <h2>{{current.data.titulo}}</h2>
                    <div class="aux">
                        <p>{{current.data.subtitulo}}</p>
                    </div>
                </div>
            </div>

            <div class="container-2">
                <div class="cont-2-1">
                    <div class="controls">
                        <div class="control prev" v-on:click="previous()" title="Previous">
                            <img src="/images/audio_next-prev.png" class="img-fluid">
                        </div>
                        <div class="control play-pause" v-on:click="playing = !playing" title="Play/Pause">
                            <img v-if="!playing" src="/images/audio_play.png" class="img-fluid">
                            <img v-else src="/images/audio_pause.png" class="img-fluid">
                        </div>
                        <div class="control next" v-on:click="next()" title="Next">
                            <img src="/images/audio_next-prev.png" class="img-fluid">
                        </div>
                    </div>

                    <div class="autoplay" title="Autoplay Off/On">
                        <label for="auto-play">Autoplay</label>
                        <div class="switch-wrap">
                            <input id="auto-play" name="auto-play" type="checkbox"/>
                            <div class="switch"></div>
                        </div>
                    </div>
                </div>
                <div class="cont-2-2">
                    <p class="player-time-current">{{ currentTime }}</p>

                    <div v-on:click="seek" class="player-progress" title="Time played : Total time">
                        <div :style="{ width: this.percentComplete + '%' }" class="player-seeker"></div>
                    </div>

                    <p class="player-time-total">{{ durationTime }}</p>
                </div>
            </div>

            <div class="container-5" style="width:8%">
                <div class="control" v-on:click.prevent="download" title="Download Audio">
                    <i class="fa fa-2x fa-download"></i>
                </div>
<!--                <div class="control" v-on:click="innerLoop = !innerLoop">-->
<!--                    <i class="fa fa-2x fa-repeat"></i>-->
<!--                </div>-->
            </div>

            <div class="container-3">
                <div class="control" v-on:click.prevent="mute" title="Mute">
                    <img src="/images/audio_volume.png" class="img-fluid">
                </div>
                <div class="control" title="Volume" style="--min:0; --max:100; --val:100;">
                    <input v-model.lazy.number="volume" v-show="showVolume" id="fld-range" type="range" min="0" max="100" orient="horizontal"/>
                    <output for="fld-range" style="display:none;">100</output>
                </div>
            </div>

            <div class="container-4">
                <div class="control" v-on:click="closePodcast" title="Close">
                    <p>Fechar</p>
                    <img src="/images/audio_close.png" class="img-fluid">
                </div>
            </div>
        </div>
        <audio :loop="innerLoop" id="audio" ref="audiofile" :src="location + '/podcasts/' + current.data.arquivo" preload="auto" style="display:none;"></audio>
    </div>




</template>

<script>
    export default {
        props: {
            location : {
                type: String,
                default: null
            },
            podcasts: {
                type: String,
                default: null
            },
            autoPlay: {
                type: Boolean,
                default: false
            },
            loop: {
                type: Boolean,
                default: false
            }
        },
        data:() => ({
            audio: undefined,
            currentSeconds: 0,
            durationSeconds: 0,
            innerLoop: false,
            loaded: false,
            playing: false,
            current: {
                index: 0,
                data: ''
            },
            numberFiles: '',
            previousVolume: 35,
            showVolume: true,
            volume: 100,
            inputRange: '',
            inputWrapper: '',
            inputOutput: '',
            auxWidth: '',
            auxPWidth: '',
            podcast: ''
        }),
        computed: {
            currentTime() {
                return this.convertTimeHHMMSS(this.currentSeconds);
            },
            durationTime() {
                return this.convertTimeHHMMSS(this.durationSeconds);
            },
            countDownTime() {
              return this.convertTimeHHMMSS(this.durationSeconds - this.currentSeconds);
            },
            percentComplete() {
                return parseInt(this.currentSeconds / this.durationSeconds * 100);
            },
            muted() {
                return this.volume / 100 === 0;
            },
        },
        watch: {
            playing(value) {
                if(value) {
                    return this.audio.play();
                }
                this.audio.pause();
            },
            volume(value) {
                //this.showVolume = false;
                this.audio.volume = this.volume / 100;
            },
        },
        methods: {
            convertTimeHHMMSS(val) {
                let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

                return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
            },
            previous() {
                //this.playing = false;
                if(this.current.index === 0) {
                    this.current.index = 14;
                    $(".podcasts-carousel").trigger('to.owl.carousel', 14);
                } else {
                    this.current.index--;
                    $(".podcasts-carousel").trigger('prev.owl.carousel');
                }
                this.current.data = this.podcast[this.current.index];
                $('audio').attr('src', this.location + '/podcasts/' + this.current.data.arquivo);
                $('.podcasts-carousel .owl-item .flip-card').removeClass("playing active");
                $('#podcast_' + this.current.index).addClass("playing active");
            },
            next() {
                //this.playing = false;
                if(this.current.index === this.numberFiles - 1) {
                    this.current.index = 0;
                    $(".podcasts-carousel").trigger('to.owl.carousel', 0);
                } else {
                    this.current.index++;
                    $(".podcasts-carousel").trigger('next.owl.carousel');
                }
                this.current.data = this.podcast[this.current.index];
                $('audio').attr('src', this.location + '/podcasts/' + this.current.data.arquivo);
                $('.podcasts-carousel .owl-item .flip-card').removeClass("playing active");
                $('#podcast_' + this.current.index).addClass("playing active");
            },
            download() {
                window.open('/downloads/podcasts/' + this.current.data.arquivo, '');
            },
            load() {
                if(this.audio.readyState >= 2) {
                    this.loaded = true;
                    this.durationSeconds = parseInt(this.audio.duration);
                    return this.playing = this.autoPlay;
                }

                throw new Error('Failed to load sound file.');
            },
            mute() {
                if(this.muted) {
                    return this.volume = this.previousVolume;
                }
                this.previousVolume = this.volume;
                this.volume = 0;
            },
            seek(e) {
                if(!this.playing || e.target.tagName === 'SPAN') {
                    return;
                }
                const el = e.target.getBoundingClientRect();
                const seekPos = (e.clientX - el.left) / el.width;

                this.audio.currentTime = parseInt(this.audio.duration * seekPos);
            },
            stop() {
                this.playing = false;
                this.audio.currentTime = 0;
            },
            update(e) {
                this.currentSeconds = parseInt(this.audio.currentTime);
            },
            closePodcast() {
                this.playing = false;
                $(".player-wrapper").css('display', 'none');
            },
            animateAudioTitle() {
                let p = $('.player-wrapper .container-1 .cont-1-2 p');
                p.delay(1000).animate({
                    left: '-' + this.auxPWidth + 50 + 'px'
                }, 1500, () => {
                    p.css("left", this.auxWidth + "px");
                    p.delay(500).animate({
                        left: '0px'
                    }, 1800, this.animateAudioTitle());
                });
            }
        },
        created() {
            this.podcast = JSON.parse(this.podcasts);
            this.current.data = this.podcast[0];
            this.numberFiles = this.podcast.length;
            this.innerLoop = this.loop;
        },
        mounted() {
            //window.audioPlayer = this;
            let context = this;
            this.audio = this.$el.querySelectorAll('audio')[0];
            this.audio.addEventListener('timeupdate', this.update);
            this.audio.addEventListener('loadeddata', this.load);
            this.audio.addEventListener('pause', () => { this.playing = false; });
            this.audio.addEventListener('play', () => { this.playing = true; });

            this.inputRange = document.getElementById('fld-range');
            this.inputWrapper = this.inputRange.parentNode;
            this.inputOutput = this.inputRange.nextElementSibling;

            $(this.inputRange).on('input', (e) => {
                this.inputOutput.value = this.inputRange.value;
                this.inputWrapper.style.setProperty('--val', + this.inputRange.value);
            });

            $("#fld-range").css("display", "block");

            if($(window).innerWidth() <= 900) {
                $(".player-wrapper .player .player-controls .cont-1-2 div").addClass("aux");
                this.auxWidth = $('.player-wrapper .container-1 .cont-1-2 .aux').width();
                this.auxPWidth = $('.player-wrapper .container-1 .cont-1-2 p').width();
                this.animateAudioTitle();
            }

            $(".flip-card .flip-card-back a").on('click', function(e) {
                context.current.index = $(this).attr("data-index");
                context.current.data = context.podcast[context.current.index];
                $(this).parents(".owl-item").siblings().children(".flip-card").removeClass("playing active");
                $(this).parents(".flip-card").addClass("playing");
                $('.player-wrapper').css('display', 'flex');
                if(context.playing === true) context.playing = !context.playing;
                $('audio').attr('src', $(event.target).parent("a").attr('href'));
            });
        }
    }
</script>

<style lang="scss">
    .control {
        cursor: pointer;
    }

    .player-wrapper {
        position: fixed;
        bottom: 0px;
        left: 0;
        display: flex;
        width: 100%;
        z-index: 1020;
        box-shadow: 0px -2px 7px 0px rgba(0,0,0,0.5);
    }
    .player {
        width: 100%;
        max-width: 1920px;
        height: 100px;
        background: #ffa339;
    }
    .player-controls {
        display: flex;
        height: 100%;
        width: 100%;
        padding: 10px 80px;
    }

    .container-1 {
        display: flex;
        width: 22%;
        .cont-1-1 {
            width: 30%;
            height: 100%;
            display: flex;
            align-items: center;
        }
        .cont-1-2 {
            padding-left: 20px;
            width: 70%;
            height: 100%;
            h2 {
                font-size: 1.15rem;
                width: 100%;
                color: #007A82;
                margin-bottom: 5px;
            }
            p {
                font-size: .85rem;
                line-height: 1rem;
                margin: 0;
                font-weight: 500;
                color: rgb(120, 102, 102);
            }
            .aux {
                -webkit-animation: move-left-right 5s infinite;
                animation: move-left-right 5s infinite;
            }
        }
    }

    .container-2 {
        display: block;
        width: 50%;
        .cont-2-1, .cont-2-2 {
            width: 100%;
            height: 50%;
            display: flex;
            margin: 0;
            align-items: center;

        }

        .cont-2-1 {
            align-items: center;
            justify-content: center;
            position: relative;
            .controls {
                display: flex;
                align-items: center;
                .control {
                    cursor: pointer;
                    margin: 0 20px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }
                .prev {
                    img {
                        transform: scale(-1);
                        width: 20px;
                    }
                }
                .next {
                    img {
                        width: 20px;
                    }
                }
                .play-pause {
                    width: 40px;
                }
            }
        }

        .cont-2-2 {
            align-items: center;
            justify-content: space-evenly;
            p {
                margin: 0;
                color: rgb(79, 127, 132);
            }
            .player-progress {
                width: 75%;
                height: 15px;
                background-color: rgb(213, 131, 37);
                cursor: pointer;
                position: relative;
                border-radius: 10px;
                .player-seeker {
                    height: 15px;
                    background-color: rgb(117, 26, 122);
                    bottom: 0;
                    left: 0;
                    position: absolute;
                    top: 0;
                    border-radius: 10px;
                }
            }
        }
    }

    .container-3 {
        width: 16%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .control {
            display: flex;
            position: relative;
            output {
                position: absolute;
                top: -25px;
                left: 0;
            }
            input[type="range"] {
                margin: auto;
                -webkit-appearance: none;
                position: relative;
                overflow: hidden;
                height: 15px;
                width: 130px;
                cursor: pointer;
                border-radius: 10px;
                &::-webkit-slider-runnable-track {
                    background: rgb(212, 130, 36);
                }
                &::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    width: 15px;
                    height: 15px;
                    background: #fff;
                    box-shadow: -10vw 0 0 9.5vw rgb(117, 26, 122);
                    border: 2px solid #fff;
                    border-radius: 10px;
                    box-sizing: border-box;
                }
            }
        }
    }

    .container-4 {
        width: 11%;
        display: flex;
        .control {
            cursor: pointer;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin: auto;
            padding-left: 10px;
            p {
                margin: 0;
                color: rgb(128, 76, 16);
            }
            img {
                width: 30px;
                height: 30px;
            }
        }
    }

    .container-5 {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 8%;
        .fa {
            color: #7f4c10;
            &.active {
                color: #751a7a;
            }
        }
    }

    .autoplay {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 150px;
        position: absolute;
        right: 7px;
        label {
            margin: 0;
            line-height: 20px;
            cursor: pointer;
        }
        .switch-wrap {
            cursor: pointer;
            background: #7f4c10;
            padding: 3px;
            width: 43px;
            height: calc(30px / 2 + 3px);
            border-radius: calc((30px / 2 + 3px) / 2);
            input {
                position: absolute;
                opacity: 0;
                width: 0;
                height: 0;
                transition: all .35s;
            }
        }
        .switch {
            height: 100%;
            display: grid;
            grid-template-columns: 0fr 1fr 1fr;
            transition: all .35s;
            &::after {
                content: '';
                border-radius: 50%;
                background: #ccc;
                grid-column: 2;
                transition: background .25s;
                width: 70%;
                margin: 0 auto;
            }
        }
        input:checked {
            + .switch {
                grid-template-columns: 1fr 1fr 0fr;
                &::after {
                    background-color: #751a7a;
                }
            }
        }
    }
</style>
